<template>
    <section class="content mt-5">
        <div class="section-home p-3 mb-3">
            <div class="row">
                <!-- Kalender -->
                <div class="col-4" style="padding-left: 2px;padding-right: 2px;">
                    <router-link to="/kalender">
                        <div class="col-sm d-flex">
                            <div class="card card-body text-center flex-fill">
                                <div class="symbol"><img src="@/assets/img/frontpage/kalender.png"/></div>
                                <div id="subtitle" class="mt-1">Kalender</div>
                            </div>
                        </div>
                    </router-link>                    
                </div>
                <!-- Diskusi Siswa -->
                <div class="col-4" v-if="check.is_tentoronline == 't'" style="padding-left: 2px;padding-right: 2px;">
                    <!-- <router-link to="/tanya-guru"> -->
                    <router-link to="/diskusi-kelas">
                        <div class="col-sm d-flex">
                            <div class="card card-body text-center flex-fill">
                                <div class="symbol"><img src="@/assets/img/frontpage/tanyaguru.png"/></div>
                                <div id="subtitle" class="mt-2">Diskusi Siswa</div>
                            </div>
                        </div>
                    </router-link>
                </div>
                <!-- Lesson Plan -->
                <div class="col-4" style="padding-left: 2px;padding-right: 2px;">
                    <router-link to="/lessonplan">
                        <div class="col-sm d-flex">
                            <div class="card card-body text-center flex-fill">
                                <div class="symbol"><img src="@/assets/img/frontpage/materi.png"/></div>
                                <div id="subtitle" class="mt-1">Lesson Plan</div>
                            </div>
                        </div>
                    </router-link>                    
                </div>
                <!-- Daftar Kehadiran -->
                <div class="col-4" style="padding-left: 2px;padding-right: 2px;">
                    <!-- <router-link to="/absensi"> -->
                    <router-link to="/absensi">
                        <div class="col-sm d-flex">
                            <div class="card card-body text-center flex-fill">
                                <div class="symbol"><img src="@/assets/img/frontpage/kalender.png"/></div>
                                <div id="subtitle" class="mt-1">Daftar Kehadiran</div>
                            </div>
                        </div>
                    </router-link>                    
                </div>
                <!-- WA Admin -->
                <div class="col-4" style="padding-left: 2px;padding-right: 2px;">
                    <a href="https://wa.me/628113144088?text=Halo%20Admin%20Taruna%20..." target="blank">
                        <div class="col-sm d-flex">
                            <div class="card card-body text-center flex-fill">
                                <div class="symbol"><img src="@/assets/img/frontpage/wa.png"/></div>
                                <div id="subtitle2">Hubungi Admin</div>
                            </div>
                        </div>
                    </a>                    
                </div>
            </div>
        </div>
        <h4>Agenda Terdekat</h4>
        <div class="mb-3" v-if="agenda.length > 0">
            <vue-horizontal-list :items="agenda" :options="{
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { size: 3 },
                ],}">
                <template v-slot:default="{item}">
                    <router-link :to="{name: 'Detail Kalender',
                                params: { k_id: item.url },}">
                        <div class="info-box">
                            <span class="info-box-icon bg-pink elevation-1">
                                <div>{{item.date}}</div>
                                <div class="muted month">{{item.month}}</div>
                            </span>
                            <div class="info-box-content">
                                <strong>{{item.mapel}}</strong>
                                <span class="info-box-text">{{item.materi}}</span>
                                <span class="info-box-text">{{item.time}}</span>
                                <span class="info-box-text">{{item.room}}</span>
                            </div>
                            <!-- /.info-box-content -->
                        </div>
                    </router-link>
                </template>
            </vue-horizontal-list>
        </div>
        <h4>Promosi</h4>
        <div class="mb-3" v-if="promotions.length > 0">
            <!--Panel Promosi-->
            <vue-horizontal-list :items="promotions" :options="{
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { size: 3 },
                ],}">
                <template v-slot:default="{item}">
                    <router-link :to="{ path: '/berita-detail/'+item.url }">
                        <div class="card mb-2">
                            <img class="" width="100%" height="200px" style="object-fit:cover" :src="url + '/file/image/' + item.img_cover" :alt="item.img">
                            <div class="card-body">
                                <h4 class="card-title">{{ item.title }}</h4>
                                <div class="card-text desc">{{ item.desc }}</div>
                            </div>
                        </div>
                    </router-link>
                </template>
            </vue-horizontal-list>
        </div>
        <!--Panel Informasi-->
        <h4>Informasi</h4>
        <div class="mb-3" v-if="woroworo.length > 0">
            <vue-horizontal-list :items="woroworo" :options="{
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { size: 3 },
                ],}">
                <template v-slot:default="{item}">
                    <router-link :to="{ path: '/pengumuman-detail/'+item.url }">
                        <div class="card mb-2">
                            <img class="" width="100%" height="200px" style="object-fit:cover" :src="url + '/file/image/' + item.img_cover" :alt="item.img">
                            <div class="card-body">
                                <h4 class="card-title mb-2">{{ item.title }}</h4>
                                <div class="card-text desc">{{ item.desc }}</div>
                            </div>
                        </div>
                    </router-link>
                </template>
            </vue-horizontal-list>
        </div>
        <!--Panel Berita-->
        <h4>Berita</h4>
        <div class="mb-3" v-if="infoNews.length > 0">
            <vue-horizontal-list :items="infoNews" :options="{
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { size: 3 },
                ],}">
                <template v-slot:default="{item}">
                    <router-link :to="{ path: '/berita-detail/'+item.url }">
                        <div class="card mb-2">
                            <img class="" width="100%" height="200px" style="object-fit:cover" :src="url + '/file/image/' + item.img_cover" :alt="item.img">
                            <div class="card-body">
                                <h4 class="card-title mb-2">{{ item.title }}</h4>
                                <div class="card-text desc">{{ item.desc }}</div>
                            </div>
                        </div>
                    </router-link>
                </template>
            </vue-horizontal-list>
        </div>
    </section>
</template>
<script>
    import VueHorizontalList from "vue-horizontal-list";
    import { auth, authFetch } from "@/libs/hxcore";
    import moment from "moment";
    import $ from 'jquery';
    export default {
    name: 'Home',
    components: {
        VueHorizontalList,
      },
    data() {
        return {
            imgUrl: 'noimg',
            agenda: [],
            info: [],
            infoNews: [],
            woroworo: [],
            promotions: [],
            url: '',
            check: {},
            promotionGroups: []
        };
    },
    created: function () {
        this.url = window.$apiUrl;
        this.isOnline();
        this.loadBerita();
        this.loadPromosi();
        this.loadPengumuman();
        this.loadAgenda();
        var info = auth.user();
        if(info)this.info = info;
        console.table(this.info)
        $('body').removeClass('sidebar-open')
        $('body').addClass('sidebar-close')
        $('body').addClass('sidebar-collapse')
    },
    methods: {
        loadBerita(){
            authFetch("/tentor/frontpage/berita").then((res) => {
                res.json().then((json) => {
                    if (json.success) {
                        let arr = [];
                        for (let i = 0; i < json.data.length; i++) {
                            arr = json.data[i];

                            this.infoNews.push({
                            filepath: arr.file_path,
                            img: arr.file_name,
                            title: arr.title,
                            url: arr.id,
                            desc: arr.deskripsi,
                            img_cover: arr.img_cover
                            });
                        }

                    }
                });
            });
        },
        loadPromosi(){
            authFetch("/tentor/frontpage/promosi").then((res) => {
                res.json().then((json) => {
                    if (json.success) {
                        let arr = [];
                        for (let i = 0; i < json.data.length; i++) {
                            arr = json.data[i];

                            this.promotions.push({
                            filepath: arr.file_path,
                            img: arr.file_name,
                            title: arr.title,
                            url: arr.id,
                            desc: arr.deskripsi,
                            img_cover: arr.img_cover
                            });
                        }
                    }
                });
            });
        },
        loadPengumuman(){
            authFetch("/tentor/frontpage/pengumuman").then((res) => {
                res.json().then((json) => {
                    if (json.success) {
                        let arr = [];
                        for (let i = 0; i < json.data.length; i++) {
                            arr = json.data[i];

                            this.woroworo.push({
                            filepath: arr.file_path,
                            img: arr.file_name,
                            title: arr.title,
                            url: arr.id,
                            desc: arr.deskripsi,
                            img_cover: arr.img_cover
                            });
                        }
                    }
                });
            });
        },
        loadAgenda(){
            authFetch("/tentor/frontpage/agenda").then((res) => {
                res.json().then((json) => {
                    if (json.success) {
                        let arr = [];
                        for (let i = 0; i < json.data.length; i++) {
                            arr = json.data[i];
                            
                            let start = arr.time_start;
                            let end = !arr.time_end ? 'selesai' : arr.time_end.split(":00+")[0];

                            this.agenda.push({
                                mapel: arr.mapel,
                                materi: arr.materi,
                                date: arr.tgl,
                                month: arr.bln,
                                time: start.split(":00+")[0] + ' - ' + end,
                                room: arr.kelas,
                                url: arr.k_id,
                                description: arr.keterangan
                            });
                        }

                        console.log(this.agenda);
                    }
                });
            });
        },
        isOnline(){
            authFetch("/tentor/frontpage/istentor_online").then((res) => {
                res.json().then((json) => {
                    if (json.success) {
                        this.check = json.data;
                    }
                });
            });
        },
    },
}
</script>
<style type="text/css">
.main-header {
    border-bottom: 0 !important;
}

.section-home {
    background: #F3F3F3;
}

.section-home .card-body {
    min-height: 100px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 2rem;
}

.symbol {
    font-size: 28px;
    margin-bottom: 5px;
}

.info-box {
    background: linear-gradient(90deg, #C9D6FF 0%, #E2E2E2 100%);
}

.bg-pink {
    background-color: #FF8181 !important;
}

.live__scroll {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
}

.live__scroll .row {
    display: block;
}

.live__scroll .live__scroll--box {
    display: inline-block;
    float: none;
    width: 60%;
    padding: 15px;
}

.month {
    font-size: 10px;
}

.info-box .info-box-icon {
    display: block;
}

.card.gradient {
    background: linear-gradient(90deg, #DD5E89 0%, #F7BB97 100%);
}

.card .overlay {
    position: absolute;
    bottom: 0;
    background: rgb(0, 0, 0);
    background: rgba(0, 0, 0, 0.5); /* Black see-through */
    width: 100%;
    transition: .5s ease;
    opacity:0.5;
    color: white;
    font-size: 20px;
    padding: 20px;
    text-align: center;
}

.desc{
    width: 300px;
    white-space:pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1rem;
}
.vhl-container{
    margin-right:0 !important;
}

@media only screen and (max-width: 555px) {
    #subtitle { font-size: 0.80rem; color: black; }
    #subtitle2 { font-size: 0.77rem; color: black; }
}

@media only screen and (min-width: 650px) {
    #subtitle { font-size: 0.95rem; color: black;}
    #subtitle2 { font-size: 0.90rem; color: black; }
}
</style>